"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = void 0;
const wait_1 = require("./wait");
const retry = async (task, onRetryableFailure, description, maxCount, delay) => {
    for (let i = 0; i < maxCount; i++) {
        try {
            const result = await task();
            return result;
        }
        catch (err) {
            if (i < (maxCount - 1)) {
                const message = `${description} failed, retrying in ${delay} ms`;
                onRetryableFailure(message, err);
                await (0, wait_1.wait)(delay);
            }
        }
    }
    throw new Error(`${description} failed after ${maxCount} attempts`);
};
exports.retry = retry;
//# sourceMappingURL=retry.js.map